import React from 'react'
import { useParams } from 'react-router'

import { AppHeader } from '../app/AppHeader'
import { CardPage } from './CardPage'

export const ClientCardPage = () => {
    const params = useParams<{ id: string }>()

    return (
        <AppHeader middleWidget={null} showBackButton title="Client">
            <CardPage clientID={params.id} />
        </AppHeader>
    )
}
